import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import axios from "axios";
import { format, parseISO } from "date-fns";

// styles

// markup
const RedirectPage = () => {
  useEffect(() => {
    (async () => {
      const liff = window.liff;
      await liff.init({ liffId: "1656224771-xqaVjQDM" });
      if (!liff.isLoggedIn()) {
        liff.login();
      } else {
        let response = await liff.getProfile();
        let dateData = new Date();
        setuserData(response);
        //alert(JSON.stringify(response));

        // const postUserData = await axios({
        //   method: "post",
        //   headers: { "Content-Type": "application/json" },
        //   url: "https://api.thedhamma.net/socialcollect/line/user/blessing",
        //   data: {
        //     id: response.userId,
        //     userName: response.displayName,
        //     userProfile: response.pictureUrl,
        //     type: "zoom",
        //     dateData: format(dateData, "dd-MM-yyyy"),
        //     timeData: format(dateData, "HH:mm"),
        //   },
        // });
        let apis = [
          "https://api.thedhamma.net/redirect/room/new",
          "https://api2.thedhamma.net/redirect/room/new",
          "https://main-api.dhammajak.live/redirect/room/new",
          "https://main-02-api.dhammajak.live/redirect/room/new",
        ];
        let api = apis[Math.floor(Math.random() * apis.length)];

        const result = await axios({
          method: "get",
          // url: "https://api.thedhamma.net/redirect/room",
          url: "https://api.thedhamma.net/redirect/room/new",
          //url: "https://api.7000tumbon.thedhamma.net/redirect/room/new",
        });
        if (result.status === 200) {
          liff.openWindow({
            url: result.data.url,
            external: true,
          });
          //window.location.href = result.data.base_url;
        } else {
          // let roomUrl =
          //   "https://zoom.us/j/94881671898?pwd=VjJ3RjVDY3VnUGpkSGVUQWQzR1RGZz09";
          // //window.location.href = roomUrl;
          // liff.openWindow({
          //   url: roomUrl,
          //   external: true,
          // });
        }
      }
    })();

    //console.log(result);
  }, []);

  const [userData, setuserData] = useState({});

  return (
    <>
      <Helmet>
        <title>Zoom on App</title>

        <meta name="format-detection" content="telephone=yes"></meta>

        <meta name="title" content="Zoom on App"></meta>
        <meta name="description" content=""></meta>

        <meta property="og:type" content="website"></meta>
        <meta property="og:url" content=""></meta>
        <meta property="og:title" content="Zoom on App"></meta>
        <meta property="og:description" content=""></meta>
        <meta property="og:image" content=""></meta>
      </Helmet>
      <main></main>
    </>
  );
};

export default RedirectPage;
